import styled from "styled-components";
import { Tab, Tabs, Grid } from "@mui/material";
import Item from "../../molecules/NavItem";

export const Wrapper = styled(Grid)`
  && {
    width: 100%;
    margin-top: 10px;
    border-top: 1px solid #f1f3f5;
  }
`;

export const StyledTabs = styled(Tabs)`
  && {
    width: 100%;
    margin-right: -50%;

    .MuiTabs-indicator {
      background-color: ${({ theme }) => theme.colors.gray[0]};
      height: 3px;
    }
  }
`;

export const StyledTab = styled(Tab)`
  && {
    background: ${({ theme }) => theme.colors.white[0]};
    box-sizing: border-box;
    border-bottom: 3px solid transparent;
    height: 40px;
    width: 148px;
    text-transform: capitalize;
    color: ${({ theme }) => theme.colors.gray[0]};
    font-family: Open Sans;
    font-style: normal;
    font-size: 14px;
    line-height: 24px;

    &.Mui-selected {
      font-weight: bold;
      color: ${({ theme }) => theme.colors.gray[0]} !important;
      border-bottom: 3px solid ${({ theme }) => theme.colors.gray[0]};
    }
  }
`;

export const NavLeft = styled.ul`
  display: flex;
  list-style-type: none;
  border: 1px solid ${({ theme }) => theme.colors.gray[theme.borders[0]]};
`;

export const NavItem = styled(Item)`
  border: ${({ hasBorder, theme }) =>
    !!hasBorder &&
    `1px solid ${
      theme.colors[theme.background.tertiary.color][
        theme.background.tertiary.intensity
      ]
    }`};
  padding: ${({ hasBorder }) => !!hasBorder && "10px 14px"};
  border-radius: ${({ hasBorder }) => !!hasBorder && "4px"};
  font-size: 16px;
  & + & {
    margin-left: ${({ hasBorder }) => (!!hasBorder ? "12px" : "0px")};
  }

  &:last-of-type {
    cursor: auto;
  }
`;
